import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@fortawesome/fontawesome-free/css/all.css';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'fa',
    },
    theme:{
        themes: {
            light: {
                primary: '#00a553',
                secondary: '#111111',
                accent: '#fff75f',
                error: '#f14400',
            },
        },
    },
});
